import { Icons } from '@Assets/SvgIcons';
import React, { FC } from 'react';
import './SearchInput.scss';

type IProps = {
  value: string;
  onChange?: (e: string) => void;
  onBlur?: (e: string) => void;
  placeholder: string;
};

const SearchInput: FC<IProps> = ({ value, onChange, onBlur, placeholder }) => {
  return (
    <div className="search-input-container">
      <Icons.SearchIcon height="18" width="18" color="#46426E" />
      <input
        value={value}
        onChange={e => onChange && onChange(e.target.value)}
        onBlur={e => onBlur && onBlur(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
};

export default SearchInput;
